import React, { FC, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { AnimalType, Equipment, LocationType } from 'shared/api/api';
import { CheckIfSectionUsesPens, ILocationModel } from 'shared/helpers/location-helper';
import { localized } from 'shared/state/i18n/i18n';
import { WebAppState } from 'web/state/store.web';
import { TextWeb } from 'web/web-helpers/styled-text-components';
import { FlexColumn } from '../../basic-flex/flex-column';
import { FlexRow } from '../../basic-flex/flex-row';
import SkioldStableSectionPicker from '../../location/location-picker/skiold-stable-section-picker';
import '../list-setup.scss';
import { ViewWeb } from '../../utils/web-view';
interface Props {
	onChangeSection: (sectionId: string, penIds: string[]) => void;
}

export const DistriwinAllAnimalsHeader: FC<Props> = React.memo(({ onChangeSection }) => {
	const [sectionId, setSectionId] = useState<string>('');

	const utps = useSelector((state: WebAppState) => state.unitToPenData.data);
	const peds = useSelector((state: WebAppState) => state.processEquipmentData.entities);
	const { sections, buildings } = useSelector((state: WebAppState) => state.locations);

	const distriwinPeds = useMemo(() => {
		return peds.filter(p => p.equipmentType === Equipment.Distriwin && !p.isFromImport);
	}, [peds]);

	const filteredLocations = useMemo(() => {
		const pedsectionIds = distriwinPeds.map(p => p.sectionId);
		const distriwinSections = sections.filter(s => pedsectionIds.includes(s.id) && s.animalType === AnimalType.Sow);
		const distriwinBuildings = buildings.filter(b => distriwinSections.find(s => s.buildingId === b.id));
		return { sections: distriwinSections, buildings: distriwinBuildings } as ILocationModel;
	}, [distriwinPeds, sections, buildings]);

	useEffect(() => {
		const ped = distriwinPeds.find(x => x.sectionId === sectionId);

		if (!ped) {
			onChangeSection(sectionId, []);
			return;
		}

		onChangeSection(
			sectionId,
			utps.filter(x => x.processEquipmentDataId === ped.id).map(x => x.penId!),
		);
	}, [utps, distriwinPeds, sectionId]);

	return (
		<FlexColumn className="work-list">
			<ViewWeb className="z-index-1000">
				<ViewWeb className="getrows">
					<ViewWeb className="flex-direction-row">
						<ViewWeb className="flexFour flex-direction-row ">
							<ViewWeb className="buttons-no-right-border">
								<TextWeb className="stable-section-text">{localized('chooseLocation')}:</TextWeb>
								<SkioldStableSectionPicker
									onStableSectionSelected={setSectionId}
									sectionId={sectionId}
									filteredLocations={filteredLocations}
									isPigProduction={true}
									containerClassName="picker-width"
								/>
							</ViewWeb>
						</ViewWeb>
					</ViewWeb>
				</ViewWeb>
			</ViewWeb>
		</FlexColumn>
	);
});
